"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { SEARCH_PALETTE_EVENT } from "@/components/site/search/events";

const SearchPalette = dynamic(
  () => import("@/components/site/search").then((m) => ({ default: m.SearchPalette })),
  { ssr: false }
);

export default function GlobalDialogs() {
  const [mountSearch, setMountSearch] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onOpenSearch = () => {
      setMountSearch(true);
      setSearchOpen(true);
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setMountSearch(true);
        setSearchOpen((prev) => !prev);
      }
    };
    window.addEventListener(SEARCH_PALETTE_EVENT, onOpenSearch);
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener(SEARCH_PALETTE_EVENT, onOpenSearch);
      window.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  return mountSearch ? <SearchPalette open={searchOpen} onOpenChange={setSearchOpen} /> : null;
}
